/* ==========================================================================
   Jardi - Application JavaScript
   ========================================================================== */

(function() {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init() {

  /* ============================
     Header - Scroll behavior
     ============================ */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ============================
     Announcement Bar - Dismiss
     ============================ */
  var announceBar = document.querySelector('[data-announcement-bar]');
  var announceClose = document.querySelector('[data-announcement-close]');

  if (announceBar && sessionStorage.getItem('jardi-announce-dismissed')) {
    announceBar.style.display = 'none';
  }

  if (announceClose) {
    announceClose.addEventListener('click', function() {
      announceBar.style.display = 'none';
      sessionStorage.setItem('jardi-announce-dismissed', '1');
    });
  }

  /* ============================
     Mobile Menu
     ============================ */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuOverlay = mobileMenu ? mobileMenu.querySelector('.mobile-menu__overlay') : null;

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  /* ============================
     Cart Drawer
     ============================ */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartToggles = document.querySelectorAll('[data-cart-toggle]');
  var cartClose = document.querySelector('[data-cart-close]');
  var cartOverlay = cartDrawer ? cartDrawer.querySelector('[data-cart-overlay]') : null;

  function openCart(e) {
    if (e) e.preventDefault();
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartToggles.forEach(function(btn) {
    btn.addEventListener('click', openCart);
  });

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (mobileMenu && mobileMenu.classList.contains('is-open')) closeMenu();
      if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    }
  });

  /* ============================
     AJAX Cart - Render drawer from JSON
     ============================ */
  function renderCartDrawer(cart) {
    var content = document.querySelector('[data-cart-content]');
    var badges = document.querySelectorAll('[data-cart-count]');

    badges.forEach(function(badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!content) return;

    if (cart.item_count === 0) {
      content.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>Your cart is empty</p>' +
          '<a href="/collections/all" class="btn btn--primary">Shop Now</a>' +
        '</div>';
      return;
    }

    var html = '<div class="cart-drawer__items">';
    cart.items.forEach(function(item) {
      var imgUrl = item.image ? (item.image.indexOf('?') > -1 ? item.image + '&width=120' : item.image + '?width=120') : '';
      html +=
        '<div class="cart-item">' +
          '<div class="cart-item__image">' +
            (item.image ? '<img src="' + imgUrl + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="60" height="60" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-item__details">' +
            '<h3 class="cart-item__title">' + item.product_title + '</h3>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
            '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
          '<div class="cart-item__quantity" data-quantity-selector>' +
            '<button type="button" data-cart-qty-decrease data-key="' + item.key + '" aria-label="Decrease quantity">\u2212</button>' +
            '<input type="number" value="' + item.quantity + '" min="1" data-cart-qty-input data-key="' + item.key + '" aria-label="Quantity" readonly>' +
            '<button type="button" data-cart-qty-increase data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="cart-item__remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove ' + item.product_title.replace(/"/g, '&quot;') + '">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
          '</button>' +
        '</div>';
    });
    html += '</div>';

    html +=
      '<div class="cart-drawer__footer">' +
        '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<p class="cart-drawer__note">Shipping calculated at checkout</p>' +
        '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>' +
        '<a href="/cart" class="btn btn--ghost" style="width: 100%; justify-content: center;">View Cart</a>' +
      '</div>';

    content.innerHTML = html;
    bindCartDrawerEvents();
  }

  function bindCartDrawerEvents() {
    document.querySelectorAll('[data-cart-qty-decrease]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var input = btn.parentElement.querySelector('[data-cart-qty-input]');
        var val = parseInt(input.value, 10);
        if (val > 1) updateCartItem(key, val - 1);
      });
    });

    document.querySelectorAll('[data-cart-qty-increase]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var input = btn.parentElement.querySelector('[data-cart-qty-input]');
        var val = parseInt(input.value, 10);
        updateCartItem(key, val + 1);
      });
    });

    document.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartDrawer(cart);
    });
  }

  /* ============================
     AJAX Add to Cart
     ============================ */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;

      var originalHTML = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        renderCartDrawer(cart);
        openCart();
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      })
      .catch(function() {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      });
    });
  });

  /* ============================
     Waitlist / Pre-launch form
     ============================ */
  document.querySelectorAll('[data-waitlist-form]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var submitBtn = form.querySelector('[type="submit"]');
      var msgEl = form.querySelector('[data-waitlist-msg]');
      var originalLabel = submitBtn ? submitBtn.textContent : '';

      if (!emailInput || !emailInput.value) return;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending\u2026';
      }
      if (msgEl) { msgEl.hidden = true; msgEl.classList.remove('is-error'); }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function(response) {
        if (msgEl) {
          msgEl.textContent = 'Reserved \u2014 we\u2019ll be in touch before the first shipment.';
          msgEl.hidden = false;
        }
        emailInput.value = '';
        if (submitBtn) submitBtn.textContent = 'Reserved';
      })
      .catch(function() {
        if (msgEl) {
          msgEl.textContent = 'Couldn\u2019t submit just now. Please try again.';
          msgEl.classList.add('is-error');
          msgEl.hidden = false;
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel || 'Reserve a spot';
        }
      });
    });
  });

  /* ============================
     Product - Variant Switching
     ============================ */
  var productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl) {
    try {
      var product = JSON.parse(productJsonEl.textContent);
      var variantButtons = document.querySelectorAll('.product-option__value');
      var selectedOptions = {};

      if (product.variants && product.variants.length > 0) {
        var firstVariant = product.variants[0];
        product.options.forEach(function(option, i) {
          selectedOptions[option] = firstVariant.options[i];
        });
      }

      variantButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var optionName = btn.dataset.optionName;
          var optionValue = btn.dataset.optionValue;

          btn.closest('.product-option__values').querySelectorAll('.product-option__value').forEach(function(b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');

          selectedOptions[optionName] = optionValue;

          var matchingVariant = product.variants.find(function(v) {
            return product.options.every(function(opt, i) {
              return v.options[i] === selectedOptions[opt];
            });
          });

          if (matchingVariant) {
            var idInput = document.querySelector('.product-hero__form input[name="id"]');
            if (idInput) idInput.value = matchingVariant.id;

            var priceEl = document.querySelector('.product-hero__price-current');
            if (priceEl) priceEl.textContent = formatMoney(matchingVariant.price);

            var compareEl = document.querySelector('.product-hero__price-compare');
            if (compareEl) {
              if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
                compareEl.textContent = formatMoney(matchingVariant.compare_at_price);
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }

            var submitBtn = document.querySelector('.product-hero__form [type="submit"]');
            if (submitBtn) {
              if (matchingVariant.available) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Add to Cart \u2014 ' + formatMoney(matchingVariant.price);
              } else {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Sold Out';
              }
            }

            var url = new URL(window.location);
            url.searchParams.set('variant', matchingVariant.id);
            history.replaceState({}, '', url);
          }
        });
      });
    } catch (e) { /* invalid JSON, skip */ }
  }

  /* ============================
     Product - Image thumbnails
     ============================ */
  var thumbnails = document.querySelectorAll('.product-hero__thumb');
  var productImages = document.querySelectorAll('.product-hero__image');

  thumbnails.forEach(function(thumb, index) {
    thumb.addEventListener('click', function() {
      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      productImages.forEach(function(i) { i.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (productImages[index]) productImages[index].classList.add('is-active');
    });
  });

  /* ============================
     Quantity Selectors (product page)
     ============================ */
  document.querySelectorAll('.product-hero__quantity [data-quantity-decrease]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      if (!input) return;
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
  });

  document.querySelectorAll('.product-hero__quantity [data-quantity-increase]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('[data-quantity-input]');
      if (!input) return;
      var val = parseInt(input.value, 10);
      input.value = val + 1;
    });
  });

  /* ============================
     Product Tabs (July-style info sections)
     ============================ */
  document.querySelectorAll('[data-product-tabs]').forEach(function(tabContainer) {
    var tabs = tabContainer.querySelectorAll('[data-tab]');
    var panels = tabContainer.querySelectorAll('[data-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = tab.getAttribute('data-tab');
        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var target = tabContainer.querySelector('[data-panel="' + index + '"]');
        if (target) target.classList.add('is-active');
      });
    });
  });

  /* ============================
     Scroll Animations (Intersection Observer)
     Spring easing + staggered delays for a premium feel.
     ============================ */
  if ('IntersectionObserver' in window) {
    var animateElements = document.querySelectorAll('[data-animate]');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Trigger the reveal
          entry.target.classList.add('is-visible');
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -60px 0px'
    });

    animateElements.forEach(function(el, idx) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      // Stagger siblings: each child in a group gets a small incremental delay
      var parent = el.parentElement;
      var siblings = parent ? parent.querySelectorAll('[data-animate]') : [];
      var siblingIndex = Array.prototype.indexOf.call(siblings, el);
      var stagger = siblingIndex >= 0 ? siblingIndex * 0.06 : 0;
      el.style.transition = 'opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1) ' + stagger.toFixed(2) + 's, transform 0.7s cubic-bezier(0.16, 1, 0.3, 1) ' + stagger.toFixed(2) + 's';
      observer.observe(el);
    });
  }

  /* ============================
     Stat Counter Animation
     Numbers count up when they enter the viewport.
     ============================ */
  (function() {
    var stats = document.querySelectorAll('[data-stat-counter]');
    if (!stats.length || !('IntersectionObserver' in window)) return;

    function animate(el) {
      var raw = el.textContent.trim();
      var match = raw.match(/^([\d.]+)(.*)/);
      if (!match) return;
      var target = parseFloat(match[1]);
      var suffix = match[2];
      var duration = 1800;
      var startTime = null;
      var hasDecimal = match[1].indexOf('.') !== -1;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = target * eased;
        el.textContent = (hasDecimal ? current.toFixed(1) : Math.round(current)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }

      el.textContent = '0' + suffix;
      requestAnimationFrame(step);
    }

    var statObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          statObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    stats.forEach(function(el) { statObserver.observe(el); });
  })();

  /* ============================
     Parallax Scroll (lerp-smoothed)
     Opt-in only via [data-parallax] — Jardi reads best static.
     ============================ */
  (function() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Store current and target values for lerp smoothing
    var state = [];
    els.forEach(function() { state.push({ current: 0, target: 0 }); });

    function lerpVal(a, b, t) { return a + (b - a) * t; }

    var running = true;

    function tick() {
      if (!running) return;
      var vh = window.innerHeight;
      var needsFrame = false;

      els.forEach(function(el, i) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -300 || rect.top > vh + 300) return;
        var img = el.querySelector('img');
        if (!img) return;

        var speed = parseFloat(el.dataset.parallax) || 0.10;
        state[i].target = (rect.top - vh / 2) * speed;
        state[i].current = lerpVal(state[i].current, state[i].target, 0.08);

        var diff = Math.abs(state[i].current - state[i].target);
        if (diff > 0.1) needsFrame = true;

        img.style.transform = 'translate3d(0,' + state[i].current.toFixed(1) + 'px,0) scale(1.08)';
      });

      if (needsFrame) {
        requestAnimationFrame(tick);
      } else {
        running = false;
      }
    }

    function wake() {
      if (!running) {
        running = true;
        requestAnimationFrame(tick);
      }
    }

    window.addEventListener('scroll', wake, { passive: true });
    requestAnimationFrame(tick);
  })();

  /* ============================
     Scroll-Reactive Ambient Glow System (Oura-inspired)
     Living gradients that move, breathe, and shift hue on scroll.
     Palette is read from CSS custom properties set in theme.liquid
     so merchants can adjust it via the customizer.
     ============================ */
  (function setupGlow() {
    // Parse a CSS color string (hex or rgb) into {r, g, b}
    function parseColor(str) {
      str = (str || '').trim();
      // hex
      if (str.charAt(0) === '#') {
        var hex = str.slice(1);
        if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        var num = parseInt(hex, 16);
        return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
      }
      // rgb(r, g, b)
      var m = str.match(/(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
      if (m) return { r: +m[1], g: +m[2], b: +m[3] };
      return null;
    }

    // Read glow intensity from CSS custom property (set by theme settings)
    var root = getComputedStyle(document.documentElement);
    var glowIntensity = parseFloat(root.getPropertyValue('--glow-intensity')) || 1;

    // If glow is disabled, skip everything
    if (glowIntensity <= 0) return;
    var fallback = [
      { r: 144, g: 144, b: 173 },
      { r: 120, g: 155, b: 145 },
      { r: 44,  g: 74,  b: 62  },
      { r: 185, g: 165, b: 120 }
    ];
    var colors = [
      parseColor(root.getPropertyValue('--jardi-glow-1')) || fallback[0],
      parseColor(root.getPropertyValue('--jardi-glow-2')) || fallback[1],
      parseColor(root.getPropertyValue('--jardi-glow-3')) || fallback[2],
      parseColor(root.getPropertyValue('--jardi-glow-4')) || fallback[3]
    ];
    // Loop back to the first color
    var palette = colors.concat([colors[0]]);

    function lerp(a, b, t) {
      return {
        r: Math.round(a.r + (b.r - a.r) * t),
        g: Math.round(a.g + (b.g - a.g) * t),
        b: Math.round(a.b + (b.b - a.b) * t)
      };
    }

    function colorAtProgress(progress) {
      var segments = palette.length - 1;
      var seg = Math.min(Math.floor(progress * segments), segments - 1);
      var local = (progress * segments) - seg;
      return lerp(palette[seg], palette[seg + 1], local);
    }

    function rgba(c, a) {
      return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + a + ')';
    }

    // Find all sections inside <main>
    var sections = document.querySelectorAll('main section');
    if (!sections.length) return;

    // Inject glow overlays
    sections.forEach(function(section) {
      if (section.querySelector('.jardi-glow')) return; // already injected

      var glow = document.createElement('div');
      glow.className = 'jardi-glow';
      glow.setAttribute('aria-hidden', 'true');

      var orb1 = document.createElement('div');
      orb1.className = 'jardi-glow__orb';

      var orb2 = document.createElement('div');
      orb2.className = 'jardi-glow__orb jardi-glow__orb--secondary';

      glow.appendChild(orb1);
      glow.appendChild(orb2);
      section.insertBefore(glow, section.firstChild);
    });

    var ticking = false;

    function update() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var docH = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var globalT = Math.min(scrollY / docH, 1); // 0 → 1 over the whole page
      var vh = window.innerHeight;

      sections.forEach(function(section) {
        var rect = section.getBoundingClientRect();
        var glowEl = section.querySelector('.jardi-glow');
        if (!glowEl) return;

        // Section progress through viewport (0 = just entered bottom, 1 = exiting top)
        var sectionH = rect.height || 1;
        var progress = (vh - rect.top) / (vh + sectionH);
        progress = Math.max(0, Math.min(1, progress));

        // Visibility — peaks when section is centered in viewport
        var centerDist = Math.abs((rect.top + sectionH / 2) - vh / 2) / (vh * 0.6);
        var visibility = Math.max(0, 1 - centerDist);
        visibility = visibility * visibility; // ease-in curve for smooth fade

        // Skip if not visible at all
        if (rect.bottom < -100 || rect.top > vh + 100) {
          glowEl.style.setProperty('--glow-opacity', '0');
          return;
        }

        // ---- Primary orb position (drifts with scroll) ----
        var glowY = 25 + progress * 50;                              // 25% → 75% top
        var glowX = 48 + Math.sin(progress * Math.PI * 2) * 12;     // gentle horizontal wave

        // ---- Secondary orb (counter-movement) ----
        var glowX2 = 62 - Math.sin(progress * Math.PI * 1.5) * 18;
        var glowY2 = 65 - progress * 30;

        // ---- Color from global scroll position ----
        var color = colorAtProgress(globalT);

        // Determine glow intensity based on section background
        // Dark/lavender sections get brighter glows
        var isDark = section.classList.contains('bg-dark') ||
                     section.classList.contains('hero--dark');
        var isLavender = section.classList.contains('bg-lavender') ||
                         section.classList.contains('hero--lavender');
        var baseOpacity = isDark ? 0.18 : (isLavender ? 0.14 : 0.10);
        var opacity = visibility * baseOpacity * glowIntensity;

        // For dark sections, shift the glow color toward lighter/warmer tones
        var c1Alpha = (isDark ? 0.22 : 0.15) * glowIntensity;
        var c2Alpha = (isDark ? 0.12 : 0.08) * glowIntensity;

        // ---- Apply CSS variables ----
        glowEl.style.setProperty('--glow-x', glowX + '%');
        glowEl.style.setProperty('--glow-y', glowY + '%');
        glowEl.style.setProperty('--glow-x2', glowX2 + '%');
        glowEl.style.setProperty('--glow-y2', glowY2 + '%');
        glowEl.style.setProperty('--glow-opacity', opacity.toFixed(3));
        glowEl.style.setProperty('--glow-color', rgba(color, c1Alpha));
        glowEl.style.setProperty('--glow-color-2', rgba(lerp(color, palette[2], 0.3), c2Alpha));

        // ---- Update card shimmer colors inside this section ----
        var cards = section.querySelectorAll('.problem-card, .feature, .detail-card, .tcard, .lifestyle-card');
        if (cards.length) {
          var cardGlow = rgba(color, 0.06 * visibility * glowIntensity);
          var cardGlowHover = rgba(color, 0.14 * glowIntensity);
          cards.forEach(function(card) {
            card.style.setProperty('--card-glow-shadow', cardGlow);
            card.style.setProperty('--card-glow-shadow-hover', cardGlowHover);
          });
        }
      });

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    // Also update on resize
    window.addEventListener('resize', function() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    // Initial paint
    update();
  })();

  /* ============================
     Rail Arrows — universal slider control
     Wires up [data-rail-arrows] wrappers that contain
     [data-rail-prev] / [data-rail-next] and reference a target
     element via data-rail-target (CSS selector).
     ============================ */
  (function() {
    var wrappers = document.querySelectorAll('[data-rail-arrows]');
    if (!wrappers.length) return;

    wrappers.forEach(function(wrap) {
      if (wrap.dataset.railBound) return;
      wrap.dataset.railBound = '1';

      var sel = wrap.dataset.railTarget;
      if (!sel) return;
      var rail = document.querySelector(sel);
      if (!rail) return;

      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');

      function getStep() {
        var visible = Array.from(rail.children).find(function(c) {
          var s = window.getComputedStyle(c);
          return s.display !== 'none' && c.offsetWidth > 0;
        });
        if (!visible) return Math.max(rail.clientWidth * 0.7, 240);
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return visible.offsetWidth + gap;
      }

      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (max <= 0) {
          wrap.setAttribute('hidden', '');
          return;
        }
        wrap.removeAttribute('hidden');
        if (prev) prev.disabled = rail.scrollLeft <= 1;
        if (next) next.disabled = rail.scrollLeft >= max;
      }

      if (prev) {
        prev.addEventListener('click', function() {
          rail.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          rail.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } // end init()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
